import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {KTSVG} from '../../../../../_metronic/helpers'
import {getReviewData} from '../BulkMessageSlice/BulkMessageSlice'
import AddTagBulk from './Components/AddTagBulk'
import StaggerConfirmationModal from './Modal/StaggerConfirmation'
import SuccessPopup from '../../../../Components/SuccessPopup'
import moment from 'moment'
import {openPopup} from '../../../../Components/PopupSlice/popupSlice'
import {checkAndFormatDate} from '../../../../Utils/_helpers'
import {Form} from 'react-bootstrap'
import {
  getAllUserDetails,
  getIsDefaultRegion,
} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useLazyGetSubClientRemainingCreditQuery} from '../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'

const ReviewBulkMessageData = ({
  bulkMessageData,
  setBulkMessageData,
  checkStep,
  setCheckStep,
  setReview,
  handleSaveData,
  sendBulkMessage,
  segmentAndTags,
  setSelectedTagIds,
}: any) => {
  const dispatch = useDispatch()
  const ReviewData = useSelector(getReviewData)
  const userData: any = useSelector(getAllUserDetails)
  const [addTagPopup, setAddTagPopup] = useState(false)
  const [tagAdded, setTagAdded] = useState(false)
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const [isSubClientLimit, setIsSubClientLimit] = useState(false)
  const [isSetCreditLimit, setIsShareCreditLimit] = useState(false)
  const [shareCreditRemain, setShareCreditRemain] = useState({
    sms: 0,
    mms: 0,
  })
  const [getRemainCredit] = useLazyGetSubClientRemainingCreditQuery()

  const [sendStaggerConfirmation, setSendStaggerConfirmation] = useState(false)

  const getTagOrSegmentName = (findIDs: any) => {
    let finalMessage = ''

    if (!findIDs) {
      return finalMessage
    }

    const groupedResult = segmentAndTags
      .flatMap((category: any) => category.options)
      .filter((option: any) => findIDs?.includes(option.value))
      .reduce((acc: any, option: any) => {
        if (!acc[option.group]) {
          acc[option.group] = []
        }
        acc[option.group].push(option)
        return acc
      }, {})

    return Object.entries(groupedResult).map(([key, value]: any) => (
      <div>
        {key} {value.length > 0 && ': ' + value.map((it: any) => it.label).join(',')}
      </div>
    ))
  }

  const StaggerSentConfirmation = useMemo(
    () => (
      <StaggerConfirmationModal
        show={sendStaggerConfirmation}
        handleClose={() => {
          setSendStaggerConfirmation(false)
        }}
        completeDate={ReviewData?.estimateDatePreview || ''}
        completeMinute={ReviewData?.estimateTimeMinute || ''}
        handleSubmit={() => sendBulkMessage()}
      />
    ),
    [ReviewData?.estimateDatePreview, sendStaggerConfirmation, ReviewData?.estimateTimeMinute]
  )

  useEffect(() => {
    if (userData && userData.subClientAccountId && userData.subClientAccountId !== '') {
      if (userData._id !== userData.ownerId) {
        setIsSubClientLimit(true)

        if (userData.subClientLimitConfig) {
          if (
            userData.subClientLimitConfig.smsLimitPerDay > 0 ||
            userData.subClientLimitConfig.mmsLimitPerDay > 0 ||
            userData.subClientLimitConfig.smsLimitPerMonth > 0 ||
            userData.subClientLimitConfig.mmsLimitPerMonth > 0
          ) {
            setIsShareCreditLimit(true)
          }
        }
      }
    }
  }, [userData])

  useEffect(() => {
    if (isSetCreditLimit === true) {
      getRemainCredit(null)
        .then((res) => {
          if ('data' in res) {
            if (res.data && res.data.data) {
              setShareCreditRemain({
                sms: res.data.data.credit.sms,
                mms: res.data.data.credit.mms,
              })
            }
          } else if ('error' in res) {
            const errObj = res.error as any
            if (errObj.data.message) {
              toast.error(errObj.data.message)
            } else {
              toast.error(res.error)
            }
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    }
  }, [isSetCreditLimit])

  const addTags = useMemo(
    () => (
      <AddTagBulk
        show={addTagPopup}
        setTagAdded={(data: any = []) => {
          if (data?.length > 0) {
            setSelectedTagIds(data)
            setTagAdded(true)
          } else {
            setTagAdded(false)
          }
        }}
        handleClose={() => {
          setAddTagPopup(false)
        }}
      />
    ),
    [addTagPopup]
  )

  const isHideSendButton = useCallback((): boolean => {
    if (isSubClientLimit && isSetCreditLimit && ReviewData && ReviewData.draftDeductibleCredits) {
      console.log('bulkMessageData.campType : ', bulkMessageData.camp_type)
      if (bulkMessageData.camp_type === 'sms') {
        return ReviewData.draftDeductibleCredits > shareCreditRemain.sms
      }

      if (bulkMessageData.camp_type === 'mms') {
        console.log(
          'isDisableSendButton  mms: ',
          ReviewData.draftDeductibleCredits > shareCreditRemain.mms
        )
        return ReviewData.draftDeductibleCredits > shareCreditRemain.mms
      }
    }
    return false
  }, [
    ReviewData,
    bulkMessageData.camp_type,
    isSetCreditLimit,
    isSubClientLimit,
    shareCreditRemain.mms,
    shareCreditRemain.sms,
  ])

  return (
    <>
      {addTags}
      {StaggerSentConfirmation}
      <div className='col-xl-8 mb-10 bg-white rounded'>
        <div className='px-8 pt-10'>
          <h2 className='msg_title'>Confirm & Send</h2>
          <p className='msg_desc'>
            If you still need more info, visit our{' '}
            <a onClick={() => dispatch(openPopup('Dummy text'))}>Help page</a>
          </p>
        </div>
        <div className='report'>
          <div className='modal-body'>
            {isHideSendButton() ? (
              <div className='col-xl-8 col-sm-8 col-md-8 col-lg-8 mb-10 alert alert-danger'>
                Your balance is insufficient to send this bulk message. Please contact your account
                manager.
              </div>
            ) : null}

            {ReviewData?.estimateDatePreview ? (
              <div className='col-xl-8 col-sm-8 col-md-8 col-lg-8 mb-10 alert alert-warning'>
                This will take {ReviewData?.estimateTimeMinute} minute to complete. The last message
                will be sent by {ReviewData?.estimateDatePreview}
              </div>
            ) : null}

            {ReviewData?.abTestingResult?.length > 0 ? (
              <>
                {ReviewData?.abTestingResult?.map((it: any, index: number) => (
                  <div className='card bg-secondary mb-2'>
                    <div className='card-body '>
                      <h2 className='mb-0 mt-0 pb-3'>Summary {index ? 'B' : 'A'}</h2>
                      <div className='row'>
                        <div className='col-sm-6 summary_block'>
                          <span className='bg-white p-2 me-2 rounded'>
                            <KTSVG
                              path='/media/icons/duotune/communication\com005.svg'
                              className='svg-icon-2x mb-2'
                            />
                          </span>
                          <div>
                            <span>
                              <strong>{it?.totalContactCount}</strong>
                            </span>
                            <p className='text-muted'>Recipients</p>
                          </div>
                        </div>
                        <div className='col-sm-6 summary_block'>
                          <span className='bg-white p-2 me-2 rounded'>
                            <KTSVG
                              path='/media/icons/duotune/general/gen028.svg'
                              className='svg-icon-2x mb-2'
                            />
                          </span>
                          <div>
                            <span>
                              <strong>
                                {it?.draftDeductibleCredits}{' '}
                                {bulkMessageData?.camp_type.toUpperCase()}
                              </strong>
                            </span>
                            <p className='text-muted'>Credits required</p>
                          </div>
                        </div>
                        <div className='col-sm-6 summary_block'>
                          <span className='bg-white p-2 me-2 rounded'>
                            <KTSVG
                              path='/media/icons/duotune/general/image 222.svg'
                              className='svg-icon-2x mb-2'
                            />
                          </span>
                          <div>
                            <span>
                              <strong>{it?.messageLength}</strong>
                            </span>
                            <p className='text-muted'>Total characters</p>
                          </div>
                        </div>
                        <div className='col-sm-6 summary_block'>
                          <span className='bg-white p-2 me-2 rounded'>
                            <KTSVG
                              path='/media/icons/duotune/general/gen040.svg'
                              className='svg-icon-2x mb-2'
                            />
                          </span>
                          <div>
                            <span>
                              <strong>
                                {index
                                  ? checkAndFormatDate(bulkMessageData?.scheduledAtSecond)
                                  : checkAndFormatDate(bulkMessageData?.scheduledAt)}
                              </strong>
                            </span>
                            <p className='text-muted'>Schedule</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className='card bg-secondary mb-2'>
                <div className='card-body '>
                  <h2 className='mb-0 mt-0 pb-3'>Summary</h2>
                  <div className='row'>
                    <div className='col-sm-6 summary_block'>
                      <span className='bg-white p-2 me-2 rounded'>
                        <KTSVG
                          path='/media/icons/duotune/communication\com005.svg'
                          className='svg-icon-2x mb-2'
                        />
                      </span>
                      <div>
                        <span>
                          <strong>{ReviewData?.totalContactCount}</strong>
                        </span>
                        <p className='text-muted'>Recipients</p>
                      </div>
                    </div>
                    <div className='col-sm-6 summary_block'>
                      <span className='bg-white p-2 me-2 rounded'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen028.svg'
                          className='svg-icon-2x mb-2'
                        />
                      </span>
                      <div>
                        <span>
                          <strong>
                            {ReviewData?.draftDeductibleCredits}{' '}
                            {bulkMessageData?.camp_type?.toUpperCase()}
                          </strong>
                        </span>
                        <p className='text-muted'>Credits required</p>
                      </div>
                    </div>
                    <div className='col-sm-6 summary_block'>
                      <span className='bg-white p-2 me-2 rounded'>
                        <KTSVG
                          path='/media/icons/duotune/general/image 222.svg'
                          className='svg-icon-2x mb-2'
                        />
                      </span>
                      <div>
                        <span>
                          <strong>{ReviewData?.messageLength}</strong>
                        </span>
                        <p className='text-muted'>Total characters</p>
                      </div>
                    </div>
                    <div className='col-sm-6 summary_block'>
                      <span className='bg-white p-2 me-2 rounded'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen040.svg'
                          className='svg-icon-2x mb-2'
                        />
                      </span>
                      <div>
                        <span>
                          <strong>{checkAndFormatDate(bulkMessageData?.scheduledAt)}</strong>
                        </span>
                        <p className='text-muted'>Schedule</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div
              className={`form-check form-check-sm form-check-custom form-check-solid new_contact_check ${
                !isDefaultRegion && 'd-none'
              }`}
            >
              <input
                className='form-check-input me-5'
                id='contact'
                checked={tagAdded}
                type={'checkbox'}
                onChange={() => setAddTagPopup(true)}
              />
              <div>
                <label htmlFor='contact' style={{lineHeight: '0.65'}}>
                  Tag new contacts
                  <span className='ms-2'>
                    <svg
                      width='16'
                      height='16'
                      viewBox='0 0 16 16'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        opacity='0.3'
                        d='M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z'
                        fill='#838492'
                      />
                      <path
                        d='M8 10.2497C7.85081 10.2497 7.70774 10.1904 7.60225 10.0849C7.49676 9.97945 7.4375 9.83638 7.4375 9.68719V9.07219C7.4305 8.69625 7.52949 8.32593 7.72314 8.00362C7.9168 7.68131 8.19728 7.42003 8.5325 7.24969C8.72899 7.15461 8.89643 7.00865 9.01744 6.82698C9.13845 6.64531 9.20862 6.43455 9.22064 6.2166C9.23266 5.99864 9.18611 5.78144 9.08581 5.58756C8.98552 5.39368 8.83514 5.23019 8.6503 5.11408C8.46546 4.99796 8.25291 4.93345 8.03471 4.92725C7.81651 4.92106 7.60063 4.97339 7.4095 5.07883C7.21837 5.18427 7.05895 5.33895 6.94781 5.52683C6.83667 5.7147 6.77787 5.92891 6.7775 6.14719C6.7775 6.29638 6.71823 6.43945 6.61274 6.54494C6.50726 6.65043 6.36418 6.70969 6.215 6.70969C6.06581 6.70969 5.92274 6.65043 5.81725 6.54494C5.71176 6.43945 5.6525 6.29638 5.6525 6.14719C5.65375 5.80373 5.73012 5.46469 5.87624 5.15386C6.02237 4.84303 6.23472 4.56792 6.4984 4.34783C6.76208 4.12773 7.07072 3.96798 7.40267 3.87977C7.73461 3.79156 8.08184 3.77703 8.42 3.83719C8.89211 3.92601 9.32594 4.15664 9.66361 4.49834C10.0013 4.84004 10.2268 5.27656 10.31 5.74969C10.4046 6.25535 10.3294 6.7781 10.0961 7.23658C9.8628 7.69506 9.48447 8.06355 9.02 8.28469C8.87783 8.36211 8.75985 8.47735 8.6791 8.61766C8.59836 8.75796 8.558 8.91787 8.5625 9.07969V9.69469C8.56052 9.84257 8.50039 9.98373 8.39512 10.0876C8.28984 10.1915 8.14789 10.2497 8 10.2497Z'
                        fill='#838492'
                      />
                      <path
                        d='M7.99999 12.1924C8.31065 12.1924 8.56249 11.9405 8.56249 11.6299C8.56249 11.3192 8.31065 11.0674 7.99999 11.0674C7.68933 11.0674 7.43749 11.3192 7.43749 11.6299C7.43749 11.9405 7.68933 12.1924 7.99999 12.1924Z'
                        fill='#7950F2'
                      />
                    </svg>
                  </span>
                </label>
                <p>Tag contacts that were part of this campaign</p>
              </div>
            </div>
            {/* <div className='d-flex align-items-center gap-4 my-2'>
              <h6
                style={{
                  fontWeight: 500,
                  margin: 0,
                }}
              >
                Send message to unsubscribe contact
              </h6>
              <Form.Check
                // onChange={(e) => setToggleHeader(!toggleHeader)}
                // checked={toggleHeader}
                className='unsub-switch'
                type='switch'
                id='custom-switch'
              />
            </div> */}
            <div className='mt-10' style={{maxWidth: '528px'}}>
              {ReviewData?.abTestingResult?.length > 0 ? (
                ReviewData?.abTestingResult?.map((it: any, index: number) => (
                  <>
                    <h2>More info {index > 0 ? 'B' : 'A'}</h2>

                    <table className='w-100 more_info'>
                      <tbody>
                        <tr>
                          <td>To</td>
                          <td className='fw-bolder'>
                            {bulkMessageData?.to?.selectedType == 'segmentOrTags'
                              ? isDefaultRegion
                                ? 'List, Segments & Tags'
                                : 'Tags'
                              : bulkMessageData?.to?.selectedType}
                          </td>
                          <td
                            onClick={() => {
                              setReview(false)
                              setCheckStep({
                                ...checkStep,
                                to: true,
                                from: false,
                                message: false,
                                gettingStarted: false,
                                when: false,
                              })
                            }}
                            className='cursor-pointer'
                          >
                            <button
                              className='bi bi-pencil-fill'
                              data-bs-toggle='collapse'
                              data-bs-target={`#collapseTwo`}
                              aria-expanded='false'
                              aria-controls='collapseTwo'
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>From</td>
                          <td className='fw-bolder'>{bulkMessageData?.sender?.value}</td>
                          <td
                            onClick={() => {
                              setReview(false)
                              setCheckStep({
                                ...checkStep,
                                to: false,
                                from: true,
                                message: false,
                                gettingStarted: false,
                                when: false,
                              })
                            }}
                            className='cursor-pointer'
                          >
                            <i className='bi bi-pencil-fill' />
                          </td>
                        </tr>
                        {bulkMessageData.staggerMessages && (
                          <tr>
                            <td>Staggering</td>
                            <td className='fw-bolder'>{`${bulkMessageData.quantity} messages every ${bulkMessageData.interval} minutes`}</td>
                            <td
                              onClick={() => {
                                setReview(false)
                                setCheckStep({
                                  ...checkStep,
                                  to: false,
                                  from: false,
                                  message: false,
                                  gettingStarted: false,
                                  when: true,
                                })
                              }}
                              className='cursor-pointer'
                            >
                              <i className='bi bi-pencil-fill' />
                            </td>
                          </tr>
                        )}
                        {bulkMessageData.isIntervalSend && (
                          <tr>
                            <td>Message Over Time</td>
                            <td className='fw-bolder'>{`send out all message in ${
                              bulkMessageData.interval
                            }  ${bulkMessageData.interval === 30 ? 'minutes' : 'hour'}  `}</td>
                            <td
                              onClick={() => {
                                setReview(false)
                                setCheckStep({
                                  ...checkStep,
                                  to: false,
                                  from: false,
                                  message: false,
                                  gettingStarted: false,
                                  when: true,
                                })
                              }}
                              className='cursor-pointer'
                            >
                              <i className='bi bi-pencil-fill' />
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td>Landing Page</td>
                          <td className='fw-bolder'>
                            {bulkMessageData.landingPageId == '' ||
                            bulkMessageData.landingPageId == undefined ? (
                              <i className='fa fa-times-circle fa-3x'></i>
                            ) : (
                              <i
                                className='fa fa-check-circle fa-3x'
                                style={{color: '#a9fec7'}}
                              ></i>
                            )}
                          </td>
                          <td
                            onClick={() => {
                              setReview(false)
                              setCheckStep({
                                ...checkStep,
                                to: false,
                                from: false,
                                message: true,
                                gettingStarted: false,
                                when: false,
                              })
                            }}
                            className='cursor-pointer'
                          >
                            <i className='bi bi-pencil-fill' />
                          </td>
                        </tr>
                        <tr>
                          <td>Tracked Links</td>
                          <td className='fw-bolder'>
                            {bulkMessageData.longUrl == '' &&
                            bulkMessageData.longUr == undefined ? (
                              <i className='fa fa-times-circle fa-3x'></i>
                            ) : (
                              <i
                                className='fa fa-check-circle fa-3x'
                                style={{color: '#a9fec7'}}
                              ></i>
                            )}
                          </td>
                          <td
                            onClick={() => {
                              setReview(false)
                              setCheckStep({
                                ...checkStep,
                                to: false,
                                from: false,
                                message: true,
                                gettingStarted: false,
                                when: false,
                              })
                            }}
                            className='cursor-pointer'
                          >
                            <i className='bi bi-pencil-fill' />
                          </td>
                        </tr>
                        <tr>
                          <td>Custom opt-out</td>
                          <td className='fw-bolder'>
                            {bulkMessageData.optout == true ? (
                              <i
                                className='fa fa-check-circle fa-3x'
                                style={{color: '#a9fec7'}}
                              ></i>
                            ) : (
                              <i className='fa fa-times-circle fa-3x'></i>
                            )}
                          </td>
                          <td
                            onClick={() => {
                              setReview(false)
                              setCheckStep({
                                ...checkStep,
                                to: false,
                                from: false,
                                message: true,
                                gettingStarted: false,
                                when: false,
                              })
                            }}
                            className='cursor-pointer'
                          >
                            <i className='bi bi-pencil-fill' />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                ))
              ) : (
                <>
                  <h2>More info</h2>
                  <table className='w-100 more_info'>
                    <tbody>
                      <tr>
                        <td>To</td>
                        <td className='fw-bolder'>
                          {bulkMessageData?.to?.selectedType == 'segmentOrTags'
                            ? isDefaultRegion
                              ? 'List, Segments & Tags'
                              : 'Tags'
                            : bulkMessageData?.to?.selectedType}
                          {bulkMessageData?.to?.selectedType == 'segmentOrTags' && (
                            <pre>{getTagOrSegmentName(bulkMessageData?.to?.value)}</pre>
                          )}
                        </td>
                        <td
                          onClick={() => {
                            setReview(false)
                            setCheckStep({
                              ...checkStep,
                              to: true,
                              from: false,
                              message: false,
                              gettingStarted: false,
                              when: false,
                            })
                          }}
                          className='cursor-pointer'
                        >
                          <button
                            className='bi bi-pencil-fill'
                            data-bs-toggle='collapse'
                            data-bs-target={`#collapseTwo`}
                            aria-expanded='false'
                            aria-controls='collapseTwo'
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>From</td>
                        <td className='fw-bolder'>{bulkMessageData?.sender?.value}</td>
                        <td
                          onClick={() => {
                            setReview(false)
                            setCheckStep({
                              ...checkStep,
                              to: false,
                              from: true,
                              message: false,
                              gettingStarted: false,
                              when: false,
                            })
                          }}
                          className='cursor-pointer'
                        >
                          <i className='bi bi-pencil-fill' />
                        </td>
                      </tr>
                      {bulkMessageData.staggerMessages && (
                        <tr>
                          <td>Staggering</td>
                          <td className='fw-bolder'>{`${bulkMessageData.quantity} messages every ${bulkMessageData.interval} minutes`}</td>
                          <td
                            onClick={() => {
                              setReview(false)
                              setCheckStep({
                                ...checkStep,
                                to: false,
                                from: false,
                                message: false,
                                gettingStarted: false,
                                when: true,
                              })
                            }}
                            className='cursor-pointer'
                          >
                            <i className='bi bi-pencil-fill' />
                          </td>
                        </tr>
                      )}
                      {bulkMessageData.isIntervalSend && (
                        <tr>
                          <td>Message Over Time</td>
                          <td className='fw-bolder'>{`send out all message in ${
                            bulkMessageData.interval === 30
                              ? bulkMessageData.interval
                              : bulkMessageData.interval / 60
                          }  ${bulkMessageData.interval === 30 ? 'minutes' : 'hour'}  `}</td>
                          <td
                            onClick={() => {
                              setReview(false)
                              setCheckStep({
                                ...checkStep,
                                to: false,
                                from: false,
                                message: false,
                                gettingStarted: false,
                                when: true,
                              })
                            }}
                            className='cursor-pointer'
                          >
                            <i className='bi bi-pencil-fill' />
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td>Landing Page</td>
                        <td className='fw-bolder'>
                          {bulkMessageData.landingPageId == '' ||
                          bulkMessageData.landingPageId == undefined ? (
                            <i className='fa fa-times-circle fa-3x'></i>
                          ) : (
                            <i className='fa fa-check-circle fa-3x' style={{color: '#a9fec7'}}></i>
                          )}
                        </td>
                        <td
                          onClick={() => {
                            setReview(false)
                            setCheckStep({
                              ...checkStep,
                              to: false,
                              from: false,
                              message: true,
                              gettingStarted: false,
                              when: false,
                            })
                          }}
                          className='cursor-pointer'
                        >
                          <i className='bi bi-pencil-fill' />
                        </td>
                      </tr>
                      <tr>
                        <td>Tracked Links</td>
                        <td className='fw-bolder'>
                          {bulkMessageData.longUrl == '' && bulkMessageData.longUr == undefined ? (
                            <i className='fa fa-times-circle fa-3x'></i>
                          ) : (
                            <i className='fa fa-check-circle fa-3x' style={{color: '#a9fec7'}}></i>
                          )}
                        </td>
                        <td
                          onClick={() => {
                            setReview(false)
                            setCheckStep({
                              ...checkStep,
                              to: false,
                              from: false,
                              message: true,
                              gettingStarted: false,
                              when: false,
                            })
                          }}
                          className='cursor-pointer'
                        >
                          <i className='bi bi-pencil-fill' />
                        </td>
                      </tr>
                      <tr>
                        <td>Custom opt-out</td>
                        <td className='fw-bolder'>
                          {bulkMessageData.optout == true ? (
                            <i className='fa fa-check-circle fa-3x' style={{color: '#a9fec7'}}></i>
                          ) : (
                            <i className='fa fa-times-circle fa-3x'></i>
                          )}
                        </td>
                        <td
                          onClick={() => {
                            setReview(false)
                            setCheckStep({
                              ...checkStep,
                              to: false,
                              from: false,
                              message: true,
                              gettingStarted: false,
                              when: false,
                            })
                          }}
                          className='cursor-pointer'
                        >
                          <i className='bi bi-pencil-fill' />
                        </td>
                      </tr>
                      <tr>
                        <td>Forwarded reply to</td>
                        <td className='fw-bolder'>
                          {bulkMessageData?.forwardReplyTo ? (
                            bulkMessageData.forwardReplyTo
                          ) : (
                            <i className='fa fa-times-circle fa-3x'></i>
                          )}
                        </td>
                        <td
                          onClick={() => {
                            setReview(false)
                            setCheckStep({
                              ...checkStep,
                              to: false,
                              from: false,
                              message: true,
                              gettingStarted: false,
                              when: false,
                            })
                          }}
                          className='cursor-pointer'
                        >
                          <i className='bi bi-pencil-fill' />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </>
              )}

              <div className='newmessage_btns mt-10'>
                <div className='btn-right'>
                  <button
                    onClick={() => setReview(false)}
                    className='btn save'
                    data-testid='btnBack'
                  >
                    Back
                  </button>
                </div>
                <div className='btn-right d-flex'>
                  {!bulkMessageData?.abTest && isDefaultRegion ? (
                    <button
                      onClick={handleSaveData}
                      className='btn save'
                      data-testid='btnSaveasTemplate'
                    >
                      Save
                    </button>
                  ) : null}

                  {!isHideSendButton() && (
                    <button
                      className={'btn  msg-primary-btn send btn-primary'}
                      data-testid='btnSendnow'
                      onClick={() => {
                        // TODO: commented out max contact removed
                        // if (ReviewData && ReviewData.totalContactCount > 200000){
                        //   return
                        // }
                        if (ReviewData?.estimateDatePreview) {
                          setSendStaggerConfirmation(true)
                        } else {
                          sendBulkMessage()
                        }
                      }}
                    >
                    {checkAndFormatDate(bulkMessageData?.scheduledAt) ? 'Schedule Now' : 'Send now'}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ReviewBulkMessageData
